import React from "react";
import { LoadingProgress } from "@/ui";
import logo from "../../assets/images/black-logo.svg";
import styles from "./AppBootScreen.module.scss";

export type AppBootScreenProps = {
    title?: string;
    subtitle?: string;
};

/**
 * Full-viewport boot screen used while the app initializes
 * (auth/SSO, Amplify, Google Maps script, F5 / store reload).
 */
export const AppBootScreen = ({
    title = "Loading Treez",
    subtitle = "Getting everything ready…",
}: AppBootScreenProps) => {
    return (
        <div className={styles.root} data-ui="app-boot-screen">
            <div className={styles.content}>
                <img alt="TREEZ" className={styles.logo} src={logo} />
                <LoadingProgress
                    className={styles.progress}
                    indeterminate
                    indicator="linear"
                    size="md"
                    subtitle={subtitle}
                    title={title}
                />
            </div>
        </div>
    );
};
